import { MotionProvider } from '@/components/marketing/site/motion-provider';
import { MarketingShell } from '@/components/marketing/site/marketing-shell';
import '@/styles/marketing.css';
import { Outlet } from 'react-router-dom';

export function MarketingLayout() {
  return (
    <div
      className="marketing-site min-h-screen overflow-x-hidden"
      style={{ fontFamily: 'var(--font-marketing-sans)' }}
    >
      <MotionProvider>
        <MarketingShell>
          <Outlet />
        </MarketingShell>
      </MotionProvider>
    </div>
  );
}
